import templateUrl from "emun.order/change-notices/change-notice-list-cards.htm";

export default () => ({ templateUrl });
